import { Button, Grid, styled } from '@/theme/index';

interface SearchButtonProps {
  label: string;
  isSelected: boolean;
  onClick: () => void;
}

export const SearchButton: React.FC<SearchButtonProps> = ({
  label,
  isSelected,
  onClick,
}) => (
  <Button
    variant={isSelected ? 'contained' : 'outlined'}
    color="success"
    onClick={onClick}
    sx={{ fontSize: '0.875rem' }}
  >
    {label}
  </Button>
);

export const StyledUnderlineButton = styled(Button)(({ theme }) => ({
  textDecoration: 'underline',
  padding: 0,
  marginTop: `${theme.spacing(2)}`,

  '&:hover': {
    opacity: '1',
    textDecoration: 'underline',
    backgroundColor: 'transparent',
  },

  '&.ymm-clear-fields': {
    marginTop: `${theme.spacing(1)}`,
  },
}));

export const StyledYmmInputsContainer = styled(Grid)(({ theme }) => ({
  '.MuiGrid-item.input-container': {
    paddingTop: '8px',

    [theme.breakpoints.up('sm')]: {
      paddingTop: '16px',
    },
  },

  '.MuiGrid-item.ymm-submit-button': {
    paddingTop: 0,
    marginBottom: 0,
  },
}));
